// @ts-nocheck

import { actionTypes } from '../constants';

// user actions
export const addItem = ({ value, oddId, betId, betTitle, outcomeLabel }) => ({
  type: actionTypes.ADD_ITEM,
  payload: {
    betTitle,
    outcomeLabel,
    value,
    oddId,
    betId,
  },
});

export const submit = () => ({
  type: actionTypes.SUBMIT,
});

export const clearBasketItem = () => ({
  type: actionTypes.CLEAR_BASKET_ITEM,
});

export const acceptChange = () => ({
  type: actionTypes.ACCEPT_CHANGE,
});

export const setStake = (stake) => ({
  type: actionTypes.SET_STAKE,
  payload: {
    stake,
  },
});

// app actions
export const setDefaultStake = (defaultStake) => ({
  type: actionTypes.SET_DEFAULT_STAKE,
  payload: { defaultStake },
});

export const onValidated = (message, optionals) => ({
  type: actionTypes.ON_VALIDATED,
  payload: {
    message,
    optionals,
  },
});

export const onError = (message, optionals) => ({
  type: actionTypes.ON_ERROR,
  payload: {
    message,
    optionals,
  },
});

export const onWaitingTraderValidation = (message, traderId) => ({
  type: actionTypes.ON_WAITING_TRADER_VALIDATION,
  payload: {
    message,
    traderId,
  },
});

export const onTraderNotification = (message, traderId, isAccepted) => ({
  type: actionTypes.ON_TRADER_NOTIFICATION,
  payload: {
    traderId,
    message,
    isAccepted,
  },
});
